import { router, type Href } from 'expo-router';
import { useCallback, useRef } from 'react';

/** A second tap inside this window is the same tap landing twice. */
const DOUBLE_TAP_MS = 800;

/** router.push, once: a double tap must not stack the same screen twice. */
export function usePushOnce(): (href: Href) => void {
  const lastPush = useRef(0);
  return useCallback((href: Href) => {
    const now = Date.now();
    if (now - lastPush.current < DOUBLE_TAP_MS) return;
    lastPush.current = now;
    router.push(href);
  }, []);
}
